import ResourceActivityList from '@/components/ResourceActivityList';
import { useStudyActivities } from '@/hooks/studies/useStudyActivities';

const StudyActivity = ({ studyId }: { studyId: string }) => {
  const { activities, isLoading } = useStudyActivities(studyId);
  return <ResourceActivityList activities={activities} isLoading={isLoading} />;
};

export default StudyActivity;
